import { render, staticRenderFns } from "./ClassVisitBehavior.vue?vue&type=template&id=2c6da4fb&scoped=true&"
import script from "./ClassVisitBehavior.vue?vue&type=script&lang=js&"
export * from "./ClassVisitBehavior.vue?vue&type=script&lang=js&"
import style0 from "./ClassVisitBehavior.vue?vue&type=style&index=0&id=2c6da4fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6da4fb",
  null
  
)

export default component.exports